import React from 'react';

/**
 * A trend, at row height.
 *
 * A table of numbers tells you the ranking; it does not tell you which of them
 * is climbing. Deliberately axis-free and label-free — it is a shape, not a
 * chart, and anything more would compete with the figures beside it.
 */
export default function Sparkline({ series, colour = 'var(--chart-1)', ariaLabel }) {
  const values = (series || []).map((v) => (Number.isFinite(v) ? v : 0));
  if (values.length < 2) return null;

  const max = Math.max(...values);
  const min = Math.min(...values);
  const span = max - min || 1;
  const points = values.map((v, i) => [
    (i / (values.length - 1)) * 100,
    24 - ((v - min) / span) * 21,
  ]);
  const [lastX, lastY] = points[points.length - 1];

  return (
    <svg
      className="sparkline"
      viewBox="0 0 100 26"
      preserveAspectRatio="none"
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    >
      <polyline
        points={points.map(([x, y]) => `${x},${y}`).join(' ')}
        fill="none"
        stroke={colour}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
      {/* The endpoint, so the eye lands on where it got to rather than where
          it has been. */}
      <circle cx={lastX} cy={lastY} r="1.8" fill={colour} vectorEffect="non-scaling-stroke" />
    </svg>
  );
}